export enum CategoriesPosition {
  TOP = 'top', // Categories displayed at the top
  SIDE = 'side', // Categories displayed at the side
}

export enum Structure {
  ONE_COLUMN = 'oneColumn',
  TWO_COLUMNS = 'twoColumns',
}

export enum ItemAppearanceStyle {
  BOX, // FAQ items displayed in a box style
  LINE, // FAQ items displayed with lines separating them
  NONE, // FAQ items displayed without any special styling
}
